<script setup>
const props = defineProps({
  filterId: { type: String, default: "" },
  attributes: {
    type: Array,
    default: [],
  },
  modelValue: {
    type: Array,
    default: [],
  },
});

const route = useRoute();

const routePath = computed(() => route.path);

watch(
  routePath,
  () => {
    searchAttribute.value = "";
  },
  { deep: true }
);

const searchAttribute = ref("");

const emit = defineEmits("update:modelValue");

const valuesFilter = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const filteredAttributes = computed(() => {
  return props.attributes.filter(function (elem) {
    if (searchAttribute.value === "") return true;
    else
      return (
        elem.name.toLowerCase().indexOf(searchAttribute.value.toLowerCase()) >
        -1
      );
  });
});

function formLabel(name, count){
  if(count>0) {
    return `${name} (${count})`
  }
  return `${name}`
}
</script>

<template>
  <div class="">
    <p-input
      v-if="attributes.length > 4"
      style-input="gray"
      height="small"
      placeholder="Поиск"
      width="regular"
      v-model="searchAttribute"
      outlined
      class="w-full outline-none h-8 mb-3"
    >
      <template #suffix>
        <template v-if="!searchAttribute.length">
          <p-icon-loop class="w-4 h-4" />
        </template>
        <template v-else>
          <p-icon-close class="w-3 h-3" @click="searchAttribute = ''" />
        </template>
      </template>
    </p-input>
    <div class="flex flex-col space-y-1">
      <p-input-checkbox
        v-for="attribute in filteredAttributes"
        :key="attribute.id"
        :id="attribute.id"
        v-model="valuesFilter"
        :value="`${attribute.filter_id}-${attribute.name}`"
        :label="formLabel(attribute.name, attribute.countProducts)"
      ></p-input-checkbox>
    </div>
  </div>
</template>
